import { setDatadogRumContext, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"

// The category hubs need explore's stylesheet for the story cards and the hub layout, but none of
// its JavaScript: `Explore()` assumes the /explore DOM and throws on the first missing container.
import "stylesheets/explore.scss"

sharedVanillaSetup()

document.addEventListener("DOMContentLoaded", function() {
  setDatadogRumContext("key-page", "story-category")
}, { once: true })
